import { footer } from '@/lib/marketing/content'

interface FooterProps {
  logoUrl?: string | null
  platformName?: string
}

export function Footer({ logoUrl, platformName = 'Ordo Golf' }: FooterProps) {
  return (
    <footer className="border-t border-[#E4FFE7]/[0.06] py-12 sm:py-16">
      <div className="max-w-[960px] mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              {logoUrl ? (
                <img src={logoUrl} alt={platformName} className="h-8 w-auto" />
              ) : (
                <>
                  <div className="w-8 h-8 rounded-xl bg-[#71ED7F] flex items-center justify-center">
                    <span className="text-[#001716] font-bold text-sm">O</span>
                  </div>
                  <span className="font-semibold text-white">{platformName}</span>
                </>
              )}
            </div>
            <p className="text-sm text-white/40 max-w-xs mb-4">
              {footer.tagline}
            </p>
            <p className="text-xs text-white/25">
              {footer.builtIn}
            </p>
          </div>

          {/* Product links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {footer.links.product.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-white/40 hover:text-[#71ED7F] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footer.links.company.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-white/40 hover:text-[#71ED7F] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-[#E4FFE7]/[0.06]">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-white/30">
              {footer.copyright}
            </p>

            {/* Status indicator */}
            <div className="flex items-center gap-2 text-xs text-white/30">
              <div className="w-2 h-2 rounded-full bg-[#71ED7F] animate-pulse" />
              All systems operational
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
